'use client';

import Fuse from 'fuse.js';
import { useEffect, useState } from 'react';

interface Props<T> {
  collection: T[];
  attributes: string[];
}

function useSearch<T>({ collection, attributes }: Props<T>) {
  const [items, setItems] = useState(collection);
  const [numItems, setNumItems] = useState(collection.length);
  const [query, setQuery] = useState('');

  const fuse = new Fuse(collection, {
    keys: attributes,
  });

  useEffect(() => {
    query.length > 0
      ? setItems(fuse.search(`=${query}`).map((result) => result.item))
      : setItems(collection);
  }, [query]);

  useEffect(() => {
    setNumItems(items.length);
  }, [items]);

  return { items, numItems, query, setQuery };
}

export { useSearch };
